export default __webpack_public_path__ + "static/media/slider3.b8da5144.jpg";